module.exports = __webpack_public_path__ + "static/img/school_logo_new.c4791aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/school_logo_new.png
// module id = cOIU
// module chunks = 1